export enum GenericConstants {
  //Login stotrage
  STORAGE_LOGIN_DATA = 'xAuthToken',
  STORAGE_ACCESS_TOKEN = 'access_token',
  STORAGE_USER_ID = 'userId',
  //resurces target
  TARGET_ITEM = 'ITEM',
  TARGET_SITE = 'SITE',
  TARGET_CHAT = 'CHAT',
  TARGET_CATEGORY = 'CATEGORY',
  TARGET_ATTRIBUTE = 'ATTRIBUTE',
}
